import { Paper, Switch } from '@mui/material';
import { Box } from '@mui/system';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React from 'react';
import AsyncBackdropSubmit from '../../components/AsyncBackdropSubmit';
import DialogAction from '../../components/Dialog/DialogAction';
import TitlePage from '../../components/layout/Page/TitlePage';
import TableGridWithFilters from '../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import HttpService from '../../services/HttpService';


export enum Api_status {
  Enabled = 'enabled',
  Disabled = 'disabled'
}

export const Api_status_Dictionary = {
  [Api_status.Enabled]: 'Ενεργό',
  [Api_status.Disabled]: 'Ανενεργό'
};

const ApisDashboard = () => {
  const [open, setOpen] = React.useState(false);
  const [status, setStatus] = React.useState({ id: null, is_enabled: false });
  const [reFetch, setReFetch] = React.useState<boolean>(false);
  const [onChangeLoading, setOnChangeLoading] = React.useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const onChangeApiUsability = async (id: number | null) => {
    setOnChangeLoading(true);
    try {
      const resp = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/locations/url/${id}`, {
        is_enabled: status.is_enabled
      });      
      if (resp.status === 200) {
        enqueueSnackbar('Επιτυχής αλλαγή κατάστασης χρήσης του Api', { variant: 'success' });
      }
      setReFetch(!reFetch);
      setOnChangeLoading(false);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });
      setOnChangeLoading(false);
    }
  };
  
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Όνομα',
      minWidth: 420,
      sortable: true
    },
    {
      field: 'last_called',
      headerName: 'Τελευταία Ημερομηνία Κλήσης',
      minWidth: 340,
      sortable: true,
      renderCell: ({row}) => row.last_called
        ? moment(row.last_called).format('DD/MM/YYYY, hh:mm:ss').toLocaleString()
        : null
    },
    {
      field: 'counter',
      headerName: 'Αριθμός Κλήσεων',
      minWidth: 305,
      sortable: true,
    },
    {
      field: 'is_enabled',
      headerName: 'On / Off',
      sortable: false,
      flex: 1,
      renderCell: ({ row }) =>
        <Switch
          checked={row.is_enabled}
          disabled={Api_status_Dictionary[Api_status.Enabled] === row.is_enabled || 
            Api_status_Dictionary[Api_status.Disabled] === row.is_enabled}
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
            setStatus({
              id: row.id,
              is_enabled: !row.is_enabled
            });
          }} />
    }
  ];

          
  return (
    <>
      <AsyncBackdropSubmit isLoading={onChangeLoading}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <TitlePage title='Διαχείριση Apis' backButton={false} />
      <Box mt={5} minWidth={350}>
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          <Box m={1} >
            <TableGridWithFilters
              responseDataFieldName='data'
              responseTotalCountFieldName = 'total_count'
              rowsPerPageOptions={[10,30,50]}
              pageSize={10}
              reFetch={reFetch}
              paginationMode='server'
              hideFilters
              columns={columns}
              fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/crm/apis`}
            />   
            <DialogAction
              open={open} title={'Αλλαγή Κατάστασης'}
              handleClose={() => {
                setOpen(false);
              }}
              content='Είστε σίγουρος/η ότι θέλετε να αλλάξετε την κατάσταση;'
              onAccept={() => {
                onChangeApiUsability(status.id);
                setOpen(false);
              }} />     
          </Box> 
        </Paper>    
      </Box>
    </>
  );
};

export default ApisDashboard;